

















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { AccountModal, SettingsModal } from '@/lazy-load-components';

import { providerPageExpTrackEvent } from '@/helpers/experiments/popular-provider-page-exp-helper';
import { ModalHelper } from '@/helpers/modal-helper';
import { SnowplowModuleContext } from '@/helpers/tracking/providers/snowplow-contexts';
import BasicButton from '@/ui-components/BasicButton.vue';

const User = namespace('user');
const TitleDetails = namespace('titleDetails');

@Component({
	name: 'LoginMenuButtonNew',
	components: {
		BasicButton,
	},
})
export default class LoginMenuButtonNew extends Vue {
	@Prop({ type: Boolean, default: false }) dark: boolean;

	@User.State loginProgress: boolean;

	@User.Getter isLoggedIn: (providerName?: string) => boolean;
	@User.Mutation SET_LOGIN_PROGRESS: (value: boolean) => void;

	@TitleDetails.Getter refferalModuleContext: SnowplowModuleContext | null;

	handleAccountClick() {
		ModalHelper.openModal(SettingsModal);
	}

	handleLoginClick() {
		ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' }, '', false, [], () =>
			this.SET_LOGIN_PROGRESS(false)
		);
		providerPageExpTrackEvent({ action: 'click', label: 'modal_opened_user_account' });
	}
}
